import React from "react";
import { tx } from "../lib/ddd/ddd";
import classes from "./Complexities.module.scss";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { ComplexityAccordion } from "../components/integrationWizard/complexity/ComplexityAccordion";

const Complexities = () => {
  return (
    <>
      <Helmet>
        <title>{tx("DDDI_Save complexity | DDD Invoices")}</title>
      </Helmet>
      <div className={`h-100 w-100 ${classes["container"]}`}>
      <ComplexityAccordion/>
      </div>
    </>
  );
};

export default Complexities;
